export enum TranscriptTypeEnum {
  RECOGNIZING = 'recognizing',
  RECOGNIZED = 'recognized',
  CANCELED = 'canceled',
  ERRORED = 'errored',
}